export const BODIMED = 'BODIMED';
export const ACIBADEM = 'ACIBADEM_SOFIA';